import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { DimensionsAndOptions } from "../types";

type GetCategoriesParams = {
	locale?: string;
	categoryId: any;
	portalUid: string;
};

const fetchCategoryDimensionsByCategoryFk = async (
	locale: string = "en-us",
	categoryId?: number,
	portalUid?: string,
): Promise<DimensionsAndOptions[]> => {
	const response = await apiDal.post("/queries/public/fetch", {
		query: "getDimensionOptionsByCategoryFk",
		bind: {
			locale: locale.toLowerCase(),
			categoryId: categoryId,
			enterpriseUid: portalUid,
		},
	});

	return response.data.result;
};

export const useGetCategoryDimensionsByCategoryIdAndEnterprise = ({
	locale,
	categoryId,
	portalUid,
}: GetCategoriesParams) => {
	return useQuery<DimensionsAndOptions[]>({
		queryKey: ["getDimensionOptionsByCategoryFk", locale, categoryId, portalUid],
		queryFn: () => fetchCategoryDimensionsByCategoryFk(locale, categoryId, portalUid),
		enabled: !!categoryId,
		initialData: [],
	});
};
